<template>
	<v-dialog v-model="dialog" max-width="600">
		<template v-slot:activator="{ on, attrs }">
			<v-btn color="secondary" class="ml-2" v-bind="attrs" v-on="on">
				<v-icon class="mr-1">mdi-plus</v-icon>
				材料項目追加
			</v-btn>
		</template>
		<v-card>
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white" class="color-white"> 材料項目追加 </v-toolbar-title>
				<v-spacer />
				<v-btn icon dark @click="closeDialog" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<div class="pa-2">
				<!-- TODO -->
				<div class="mt-2">
					<v-form ref="form" v-model="valid">
						<IncrementalSearchForm
							:label="'材料名'"
							:value.sync="item"
							:classArray="['append-outer']"
							requireEmit
							required
							returnObjectWhenEmit
							:url="'TODO'"
							@change="changeItem($event)"
						>
							<template v-slot:append-outer>
								<ConstructionStockItemNewDialog @create-item="createItem($event)" />
							</template>
						</IncrementalSearchForm>

						<table
							v-if="type == 'rubber'"
							width="100%"
							class="show-dialog-table show-dialog-table--form"
						>
							<tbody>
								<ShowDetailRecord :columnName="'材料名'" :value="'XX'" :tdStyle="{backgroundColor:'white'}" />
								<ShowDetailRecord :columnName="'ロット'">
									<template v-slot:value>
										<v-text-field
											v-model="TODO"
											background-color="white"
											:rules="[rules.required]"
											dense
											outlined
											hide-details
										/>
									</template>
								</ShowDetailRecord>
								<ShowDetailRecord :columnName="'厚み(mm)'">
									<template v-slot:value>
										<v-text-field
											v-model="TODO"
											background-color="white"
											:rules="[rules.required]"
											dense
											outlined
											hide-details
										/>
									</template>
								</ShowDetailRecord>
								<ShowDetailRecord :columnName="'幅(mm)'">
									<template v-slot:value>
										<v-text-field
											v-model="TODO"
											background-color="white"
											:rules="[rules.required]"
											dense
											outlined
											hide-details
										/>
									</template>
								</ShowDetailRecord>
								<ShowDetailRecord :columnName="'長さ(新品)(m)'">
									<template v-slot:value>
										<v-text-field
											v-model="TODO"
											background-color="white"
											:rules="[rules.required]"
											dense
											outlined
											hide-details
										/>
									</template>
								</ShowDetailRecord>
							</tbody>
						</table>
						<table
							v-if="type == 'item_kg'"
							width="100%"
							class="show-dialog-table show-dialog-table--form"
						>
							<tbody>
								<ShowDetailRecord :columnName="'材料名'" :value="'XX'" :tdStyle="{backgroundColor:'white'}" />
								<ShowDetailRecord :columnName="'ロット'">
									<template v-slot:value>
										<v-text-field
											v-model="TODO"
											background-color="white"
											:rules="[rules.required]"
											dense
											outlined
											hide-details
										/>
									</template>
								</ShowDetailRecord>
								<ShowDetailRecord :columnName="'入り目(kg)'">
									<template v-slot:value>
										<v-text-field
											v-model="TODO"
											background-color="white"
											:rules="[rules.required]"
											dense
											outlined
											hide-details
										/>
									</template>
								</ShowDetailRecord>
							</tbody>
						</table>
						<table
							v-if="type == 'item_quantity'"
							width="100%"
							class="show-dialog-table show-dialog-table--form"
						>
							<tbody>
								<ShowDetailRecord :columnName="'材料名'" :value="'XX'" :tdStyle="{backgroundColor:'white'}" />
								<ShowDetailRecord :columnName="'ロット'">
									<template v-slot:value>
										<v-text-field
											v-model="TODO"
											background-color="white"
											:rules="[rules.required]"
											dense
											outlined
											hide-details
										/>
									</template>
								</ShowDetailRecord>
							</tbody>
						</table>
					</v-form>
				</div>
			</div>
			<v-card-actions>
				<v-row no-gutters>
					<v-col sm="2" cols="0" />
					<v-col sm="8" cols="12" class="text-center">
						<v-btn color="secondary" @click="createStockItem" :disabled="!valid">
							<v-icon class="mr-1">mdi-plus</v-icon>
							追加する
						</v-btn>
					</v-col>
					<v-col sm="2" cols="0" class="text-right">
						<v-btn v-if="!$vuetify.breakpoint.xs" color="grey darken-1" text @click="closeDialog">
							キャンセル
						</v-btn>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import rules from "../../../helper/rules"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"
import IncrementalSearchForm from "../../shared/IncrementalSearchForm.vue"
import ConstructionStockItemNewDialog from "./ConstructionStockItemNewDialog.vue"

export default {
	components: {
		ShowDetailRecord,
		IncrementalSearchForm,
		ConstructionStockItemNewDialog,
	},
	data() {
		return {
			item: null,
			type: null,
			TODO: null,
			dialog: false,
			valid: false,
			rules,
		}
	},
	methods: {
		// TODO: 決定したモデル名にメソッド名なども変更すること
		createStockItem() {
			// TODO:
		},
		createItem(item) {
			// TODO:
			this.type = item.type
		},
		changeItem(item) {
			// TODO:
			this.type = item.type
		},
		closeDialog() {
			this.dialog = false
		},
	},
}
</script>